import { PluginType } from '@deephaven/plugin';
import MarkdownPlugin from "./MarkdownPlugin.js";
var MarkdownPluginConfig = {
  name: 'MarkdownPlugin',
  type: PluginType.DASHBOARD_PLUGIN,
  component: MarkdownPlugin
};
export default MarkdownPluginConfig;
//# sourceMappingURL=MarkdownPluginConfig.js.map